define(()=> {
    function isPromise(value) {
        return value && typeof value.then === 'function';
    }

    function isMessagePlusInterpolation(value) {
        return value && typeof value.key === 'string';
    }

    return ['$scope', '$filter', '$translate', '$q', 'model','$modalInstance', 'LoadSaveService', 'ModalService','$rootScope','MembershipService', ($scope, $filter, $translate, $q, model,$modalInstance, LoadSaveService,ModalService, $rootScope, MembershipService)=> {
        function translate(val) {
            if (isPromise(val)) {
                return val;
            }
            if (isMessagePlusInterpolation(val)) {
                return $translate(val.key, val.args || {});
            }
            return $q.when(typeof val === 'string' && val.length ?
                $translate(val) :
                val);
        }

        function writeToScope(prop) {
            return (msg)=> {
                $scope[prop] = msg;
            };
        }
        $scope.selectedMembershipNumber = '';
        $scope.draftData = {};
        //This is used for contact details page disclaimer
        $scope.nextState = function (){
        $modalInstance.close();
        }

        $scope.addressConfirmed = function (actionType){
        var result = {actionType:actionType}
        
        // console.log("Modal window for addrsss Std"  , actionType, "Scope options ",$scope.customOptions)
            $modalInstance.close(result);
        }

        $scope.iconClass = model.iconClass;
        $scope.showCancelBtn = model.showCancelBtn;
        $scope.cancelBtnLabel = model.cancelBtnLabel;
        $scope.customOptions = model.customOptions;

        translate(model.title).then(writeToScope('title'));
        translate(model.message).then(writeToScope('message'));
        translate(model.description).then(writeToScope('description'));

        if (model.action) {
            $scope.action = {
                btnClass: model.action.btnClass || 'gw-btn-primary',
                label: model.action.label || $filter('translate')('platform.modal.ModalCtrl.OK')
            };
        }
        // removed quoteAsNonMember, showMemberWarning, membershipValidation and added in PAPolicyInfoCtrl.js
    }];
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/modal/ModalCtrl.js
 **/